const asset = (name) => `/generated/${name}.png`;

/** MediaItem interface implemented as plain JS objects. */
export const MEDIA = [
  {
    id: "m1",
    type: "youtube",
    title: "Post-Renovation Cleaning — Full Walkthrough",
    description: "See our team completing a post-renovation deep clean.",
    serviceCategory: "Post Renovation",
    propertyType: "BTO",
    youtubeUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
    youtubeVideoId: "dQw4w9WgXcQ",
    thumbnailUrl: asset("service_post_reno"),
    altText: "Emilio's Solutions post-renovation cleaning walkthrough",
    featured: true,
    active: true,
    displayOrder: 1,
    createdAt: "2026-01-05",
  },
  {
    id: "m2",
    type: "youtube",
    title: "Deep Floor Scrub — Marble Restoration",
    description: "Commercial rotary scrub on marble floors.",
    serviceCategory: "Floor Cleaning",
    propertyType: "Condo",
    youtubeUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
    youtubeVideoId: "dQw4w9WgXcQ",
    thumbnailUrl: asset("service_deep_floor"),
    altText: "Emilio's Solutions deep floor cleaning",
    featured: true,
    active: true,
    displayOrder: 2,
    createdAt: "2026-01-08",
  },
  {
    id: "m3",
    type: "youtube",
    title: "Sofa & Mattress Refresh",
    description: "Professional upholstery extraction in a condo.",
    serviceCategory: "Sofa Cleaning",
    propertyType: "Condo",
    youtubeUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
    youtubeVideoId: "dQw4w9WgXcQ",
    thumbnailUrl: asset("service_sofa"),
    altText: "Sofa cleaning process",
    featured: false,
    active: true,
    displayOrder: 3,
    createdAt: "2026-01-11",
  },
];

// Before-after pairs (we reuse the same images since they simulate — clearly labelled sample)
export const BEFORE_AFTER = [
  {
    id: "ba1",
    title: "Kitchen after renovation",
    serviceCategory: "Post Renovation",
    propertyType: "Condo",
    beforeImageUrl: asset("intro_2"),
    afterImageUrl: asset("hero_home"),
    altText: "Before and after — condo kitchen post renovation",
    featured: true,
    active: true,
    displayOrder: 1,
  },
  {
    id: "ba2",
    title: "Marble floor deep scrub",
    serviceCategory: "Floor Cleaning",
    propertyType: "Condo",
    beforeImageUrl: asset("service_deep_floor"),
    afterImageUrl: asset("hero_whyus"),
    altText: "Marble floor before and after",
    featured: false,
    active: true,
    displayOrder: 2,
  },
  {
    id: "ba3",
    title: "Empty unit for handover",
    serviceCategory: "End of Tenancy",
    propertyType: "HDB",
    beforeImageUrl: asset("audience_tenants"),
    afterImageUrl: asset("service_end_tenancy"),
    altText: "HDB unit before and after end of tenancy clean",
    featured: false,
    active: true,
    displayOrder: 3,
  },
];

export const GALLERY_CATEGORIES = [
  "All",
  "Post Renovation",
  "End of Tenancy",
  "Floor Cleaning",
  "Sofa Cleaning",
  "Mattress Cleaning",
  "Pressure Washing",
  "Commercial Cleaning",
  "Defect Inspection",
];
